module.exports = __webpack_public_path__ + "static/img/sale.1ed638a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/sale.png
// module id = 5EKI
// module chunks = 1